"use client";
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from "react";
import { Global } from "@emotion/react";
import { resetCSS, globalCSS } from "@cbex/utils/theme";
import { Header } from "@cbex/ui/header";
import { Stack } from "@mui/material";
import { SnackbarProvider } from "notistack";

interface LayoutProps {
  children?: React.ReactNode;
  title: string;
}

export const BasePage = ({ children = true, title }: LayoutProps) => (
  <SnackbarProvider
    autoHideDuration={3000}
    maxSnack={3}
    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
  >
    <Global styles={[resetCSS, globalCSS]} />
    <Stack id="BasePage" height="100%">
      <Header />
      {children}
    </Stack>
  </SnackbarProvider>
);
